export default __webpack_public_path__ + "static/media/fac1.72462a22.png";